(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/info-card.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/info-card.js');
"use strict";


const {
  RibbonCorner
} = svs.ui.ReactRibbon;
const {
  trackPlay
} = svs.eInstant.tracking;
const {
  Card
} = svs.ui.ReactCard;
const {
  useHistory
} = ReactRouterDOM;
const {
  validateGameConfig
} = svs.eInstant.util;
const {
  ImageMemo
} = svs.eInstant.shared.components;
const InfoCard = _ref => {
  let {
    ticketConfig: game
  } = _ref;
  const {
    ButtonsBlock
  } = svs.eInstant.shared.components;
  const history = useHistory();
  if (!validateGameConfig(game)) return null;
  const handleClickPlay = e => {
    if (svs.tur.PauseCheck.isBlocked()) {
      svs.tur.apierrors.showErrorMessage({
        response: {
          error: {
            code: 1019
          }
        }
      });
      return;
    }
    e.preventDefault();
    trackPlay(game.name, false);
    history.push("".concat(game.playUrl, "?returnUrl=").concat(encodeURIComponent(location.pathname)));
  };
  const handleClickDemoPlay = e => {
    e.preventDefault();
    trackPlay(game.name, true);
    history.push("".concat(game.demoUrl, "?returnUrl=").concat(encodeURIComponent(location.pathname)));
  };
  const previewImage = game.gamePreview || game.imageBackground;
  return React.createElement("div", {
    className: "einstant-info-card-wrapper w100",
    "data-testid": "featured-game-mobile"
  }, React.createElement(Card, {
    className: "f-body margin-h-1 margin-v-1"
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center relative einstant-info-card-background"
  }, React.createElement(ImageMemo, {
    fitWrapper: true,
    image: previewImage,
    loadingLazy: true
  }), game.logotype && React.createElement(ImageMemo, {
    cssSelectors: "padding-half",
    image: game.logotype,
    loadingLazy: true
  })), game.badge && React.createElement(RibbonCorner, {
    className: "ribbon-corner-branding-fler-lotter",
    size: 500
  }, game.badge), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-between u-flex-align-items-center padding-1 bg-fler-lotter-new-500"
  }, React.createElement("h2", {
    className: "h2 align-center fc-fler-lotter-new-300 margin-bottom-half"
  }, game.name), React.createElement("div", {
    className: "margin-bottom-1 u-flex u-flex-column u-flex-align-items-center align-center"
  }, game.tags.length > 0 && React.createElement("p", {
    className: "fc-fler-lotter-new-300 margin-bottom-1 f-400 clip tickets-einstant-info-card-tags align-center"
  }, game.tags.join(', ')), game.description && React.createElement("p", {
    className: "p fc-fler-lotter-new-400 clip tickets-einstant-info-card-description align-center"
  }, game.description)), React.createElement("div", {
    className: "w100"
  }, React.createElement(ButtonsBlock, {
    game: game,
    onDemoClick: handleClickDemoPlay,
    onPlayClick: handleClickPlay
  }), React.createElement("div", {
    className: "u-bottom-0 w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-row u-flex-align-items-center u-flex-justify-content-between fc-fler-lotter-new-300"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("span", {
    className: "f-100"
  }, "Insats"), React.createElement("span", {
    className: "f-bold"
  }, game.maxPrice ? "".concat(game.minPrice, " - ").concat(game.maxPrice, " kr") : "".concat(game.minPrice, " kr"))), React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement("span", {
    className: "f-100"
  }, "Maxvinst"), React.createElement("span", {
    className: "f-bold"
  }, "".concat(svs.utils.format.Currency(game.maxWin), " kr"))))))), game.imageOverlay && React.createElement("div", {
    className: "einstant-info-card-image-overlay"
  }, React.createElement(ImageMemo, {
    fitWrapper: true,
    image: game.imageOverlay,
    loadingLazy: true
  })))));
};
setGlobal('svs.eInstant.components.InfoCard', InfoCard);

 })(window);